'use client';

import { c as _c } from "react/compiler-runtime";
import { Select } from 'antd';
import { useMemo } from 'react';
import type { GalleryContentProps } from '@/services/sanity';
type GalleryFiltersProps = {
  galleryContent: GalleryContentProps[];
  selectedBrainRegion: string | null;
  // selectedMediaType: string | null;
  onBrainRegionChange: (value: string | null) => void;
  // onMediaTypeChange: (value: string | null) => void;
};
export default function GalleryFilters(t0) {
  const $ = _c(13);
  const {
    galleryContent,
    selectedBrainRegion,
    onBrainRegionChange
  } = t0;
  let t1;
  if ($[0] !== galleryContent) {
    const regions = new Set();
    galleryContent.forEach(item => {
      if (item.brainRegion) {
        regions.add(item.brainRegion);
      }
    });
    t1 = Array.from(regions).sort();
    $[0] = galleryContent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const brainRegions = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontFamily: "var(--font-titillium-web)"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="text-sm font-semibold">Brain Region</div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = selectedBrainRegion ?? "all";
  let t5;
  if ($[4] !== onBrainRegionChange) {
    t5 = value => onBrainRegionChange(value === "all" ? null : value);
    $[4] = onBrainRegionChange;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      value: "all",
      label: "All"
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== brainRegions) {
    t7 = [t6, ...brainRegions.map(_temp)];
    $[7] = brainRegions;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t7) {
    t8 = <div className="grid grid-cols-2 gap-4 md:flex" style={t2}><div className="flex flex-col gap-2">{t3}<Select aria-label="Brain Region filter" placeholder="All brain regions" allowClear={true} value={t4} onChange={t5} className="min-w-[200px] capitalize" options={t7} /></div></div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}
function _temp(region) {
  return {
    value: region,
    label: region
  };
}